import React, { useState } from "react";
import { useSettings } from "context/Settings.context";
import Button from "components/Common/Button/Button";
import Modal from "components/Common/Modal/Modal";
import TextField from "../../../components/Common/TextField/TextField";
import FetchZoomFileModalContainer from "./FetchZoomFileModal.styles";

interface Props {
    onClose: () => void;
    onConfirm: (zoomMeetingId: string) => void;
}

const FetchRecordingUrlModal = ({ onClose, onConfirm }: Props) => {
    const { setToast } = useSettings();
    const [zoomMeetingId, setZoomMeetingId] = useState("");

    const isFormValid = (): boolean => {
        if (!zoomMeetingId || zoomMeetingId.trim() === "") {
            setToast({
                show: true,
                type: "error",
                message: "Please enter a valid Zoom meeting ID",
            });
            return false;
        }
        return true;
    };

    const handleConfirm = () => {
        if (isFormValid()) {
            const id = zoomMeetingId.trim().replace(/[\s-]/g, "");
            onConfirm(id);
        }
    };

    return (
        <FetchZoomFileModalContainer>
            <Modal onClose={onClose}>
                <div className="main">
                    <div className="text">
                        <h3>Fetch recording link</h3>
                        <p>
                            No recording link is stored for this meeting yet.
                            Enter the Zoom meeting ID to load the cloud play URL
                            from Zoom. If the recording is still processing, try
                            again in a few minutes.
                        </p>
                    </div>
                    <TextField
                        label="Zoom meeting ID"
                        placeholder="Enter Zoom meeting ID"
                        change={(val: string) => setZoomMeetingId(val)}
                        value={zoomMeetingId}
                        type="text"
                    />
                </div>
                <div className="actions">
                    <Button text="CANCEL" color="flat" click={onClose} />
                    <Button text="FETCH AND OPEN" click={handleConfirm} />
                </div>
            </Modal>
        </FetchZoomFileModalContainer>
    );
};

export default FetchRecordingUrlModal;
